// Static estimated or rollup duration badge with optional estimated dash prefix.
import { visuallyHidden } from '@mui/utils';
import { formatHours } from '@/components/ui/formatHours';
import { useT } from '@/i18n/useT';
import {
  getDurationPrefixKind,
  getDurationPrefixGlyph,
} from './buildDurationPrefix';

const ROLLUP_DURATION_KEY = 'taskdetailmetadata.rollupDuration';
const ESTIMATED_DURATION_KEY = 'taskdetailmetadata.estimatedDuration';

const renderAccessibleDurationPrefix = (kind, t) => {
  if (!kind) return null;
  const glyph = getDurationPrefixGlyph(kind);
  const hiddenLabel =
    kind === 'rollup'
      ? t(
          ROLLUP_DURATION_KEY,
          'Calculated duration (sum of subtasks)',
        )
      : t(ESTIMATED_DURATION_KEY, 'Estimated duration');
  return (
    <>
      <span aria-hidden="true">{glyph}</span>
      <span style={visuallyHidden}>{hiddenLabel}</span>
    </>
  );
};

export function StaticDurationBadge({
  displayDuration,
  isRollup,
  className,
  showIcon,
  showPrefix,
  title,
}) {
  const t = useT();
  const showEstimatedIndicator = Boolean(showIcon && !isRollup);
  const effectivePrefixKind = getDurationPrefixKind(
    isRollup,
    showPrefix || showEstimatedIndicator,
  );

  return (
    <span className={className} title={title}>
      {renderAccessibleDurationPrefix(effectivePrefixKind, t)}
      {displayDuration > 0 ? formatHours(displayDuration / 60) : ''}
    </span>
  );
}
